import cn from 'classnames';
import st from './Loader.module.scss';

interface Props {
  text?: string;
  className?: string;
  disableMargin?: boolean;
  inCenter?: boolean;
}

const Loader = ({ text, disableMargin = false, inCenter = false, className }: Props) => {
  return (
    <div
      className={cn(
        st.loader,
        disableMargin && st.disableMargin,
        inCenter && st.inCenter,
        className ? className : ''
      )}
    >
      <div className={st.spinner} />
      {text && <h3>{text}</h3>}
    </div>
  );
};

export default Loader;
